module.exports = __webpack_public_path__ + "static/img/iphone_msptitle5.520527b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/iphone_msptitle5.png
// module id = 9gXN
// module chunks = 0